/**
 * @hidden
 */
export let defaultHttpAgent;
/**
 * @hidden
 */
export let defaultHttpsAgent;
//# sourceMappingURL=defaultAgent.browser.js.map